/* @flow */
import { Map, Record } from 'immutable';

export type PositionsType = Map<string, number>;

export type DetailPanelRecordType = Record<{
  detailType: string,
  showExtendedContent: boolean,
}>;

export const detailPanelRecord = Record({
  detailType: 'content',
  showExtendedContent: false,
});



// WEBPACK FOOTER //
// ./src/app/modules/display/types.js